<div class="main_content">
  <app-breadcrumb></app-breadcrumb>
  <div #page_section class="page_main_sec">
    <div class="emailmanager_main_sec">
      <!-- title bar section Start-->
      <div class="container-fluid">
        <!-- <div class="post-nav-wrap">
          <div class="title-wrap">
            <p class="title">Email Template</p>
          </div>
          <ul class="nav top-actions">
            <li>
              <a [routerLink]="['/home']">
                <i class="material-icons theme-text-color">home</i>
              </a>
            </li>
          </ul>
        </div> -->
      </div>
      <!-- title bar section  End-->
    </div>

    <!-- Form Field section Start-->
    <div class="tab-content">
      <div>
        <!-- Table View -->
        <div class="table_card_sec mb_0">
          <div class="table scroll_table">
            <div class="row">
              <div class="col-md-4">
                <div class="row">
                  <div *ngFor="let field of lstMacroFields">
                    <button class="accordion">{{ field.text }}</button>
                    <div class="panel">
                      <mat-selection-list [multiple]="false">
                        <mat-list-option *ngFor="let child of field.item" [value]="child.text"
                          (click)="onChangeFieldBody(child.text)">
                          {{child.text}}
                        </mat-list-option>
                      </mat-selection-list>
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-md-8">

                <div class="row">
                  <mat-form-field [style.width.%]="100">
                    <mat-label for="document_type">Document Type</mat-label>
                    <mat-select [ngModel]="ddlDocumentType"
                      (selectionChange)="onDocmentTypeSelectionChanged($event.value)" id="document_type">
                      <mat-option *ngFor="let doc of lstDocumentType" [value]="doc.value">
                        {{ doc.text }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>


                <div class="row">
                  <mat-form-field [style.width.%]="100">
                    <mat-label for="template_name">Template Name</mat-label>
                    <input matInput [ngModel]="emailTemplateName" id="template_name" />
                  </mat-form-field>
                </div>

                <div class="row">
                  <mat-form-field [style.width.%]="100">
                    <mat-label for="email_subject">Email Subject</mat-label>
                    <input matInput #elSubject [(ngModel)]="emailSubject" (focus)="focusFunction('subject')"
                      (focusout)="focusOutFunction('subject')" id="email_subject" />
                  </mat-form-field>
                </div>
                <div class="row">
                  <mat-label>Email Body</mat-label>
                  <div [style.width.%]="100" [formGroup]="bodyform">
                    <div class="editor">
                      <ngx-editor-menu [editor]="bodyEditor" [toolbar]="toolbar">
                      </ngx-editor-menu>
                      <ngx-editor [editor]="bodyEditor" formControlName="editorContent">
                      </ngx-editor>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">

                    <app-dropdown-multiselect #ddlFieldsforBody [labelText]="'Select Additional Feature'"
                      [lstDropdownOption]="lstAdditionalFeature" [allSelected]="false">
                    </app-dropdown-multiselect>

                  </div>
                  <div class="col-lg-6">
                    <mat-form-field [style.width.%]="100">
                      <mat-label for="status">Status</mat-label>
                      <mat-select [ngModel]="emailTemplateStatus" id="status">
                        <mat-option *ngFor="let stat of lstTemplateStatus" [value]="stat.value">
                          {{stat.text}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-12 btn-emailtemplate">

                  <button mat-raised-button class="mr-2 smallButton" (click)="saveEmailTemplate()">
                    Save
                  </button>
                  <button mat-raised-button class="resetButton" (click)="clearTemplateForm()">
                    Clear
                  </button>
                </div>

              </div>
            </div>



            <!-- Table View -->
          </div>

        </div>

      </div>
    </div>
  </div>